// Curated Unsplash nature photos — Pacific Northwest / Cascades / forests / lakes
// Direct CDN URLs (no API key needed). Sized for typical kiosk resolutions.
export const NATURE_PHOTOS = [
  "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1418065460487-3e41a6c84dc5?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1426604966848-d7adac402bff?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1472214103451-9374bd1c798e?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1502082553048-f009c37129b9?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1465056836041-7f43ac27dcb5?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1518173946687-a4c8892bbd9f?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1486916856361-cb6760e0a8db?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1454496522488-7a8e488e8606?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1483728642387-6c3bdd6c93e5?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1444090542259-0af8fa96557e?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1493514789931-586cb221d7a7?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1476610182048-b716b8518aae?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1511497584788-876760111969?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1455218873509-8097305ee378?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1448375240586-882707db888b?w=2400&q=80&fm=jpg",
  "https://images.unsplash.com/photo-1473773508845-188df298d2d1?w=2400&q=80&fm=jpg",
];

export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}
